import { cn } from "@koclukpanel/ui";

/**
 * ALAN SEKMELERİ — UI/UX Dalga 2 (M1)
 *
 * Yan menüdeki girdi bir ALAN (bkz. `menu-alanlari.ts`); alanın içindeki
 * ekranlar sayfa başlığının altında bu şeritte duruyor. Şerit bir GEZİNTİ,
 * ARIA "tab" deseni değil: her düğme ayrı bir sayfa (adres) açıyor ve altında
 * paylaşılan bir `tabpanel` yok. `role="tab"` yazmak ok tuşu gezinmesi ve
 * `tabpanel` bağı vaat ederdi — eksik kurulmuş bir ARIA deseni hiç
 * yazmamaktan kötü (`Kvkk.tsx`teki gerekçenin aynısı).
 *
 * SARILIYOR, KAYDIRILMIYOR: yatay kaydırılan şerit, görünmeyen sekmelerin
 * VAR OLDUĞUNU da gizler ("Teknik ve denetim" alanında on tane var).
 *
 * Tek görünen sekmesi olan alanda şerit hiç çizilmiyor (çağıran karar veriyor):
 * tek düğmelik bir gezinti gürültüdür.
 */
export interface AlanSekmesi {
  /** Ekran anahtarı. */
  anahtar: string;
  etiket: string;
}

export function AlanSekmeleri({
  sekmeler,
  aktif,
  onSec,
}: {
  sekmeler: readonly AlanSekmesi[];
  aktif: string;
  onSec: (ekran: string) => void;
}) {
  return (
    <nav aria-label="Bu alandaki ekranlar" className="mb-5 flex flex-wrap gap-1.5">
      {sekmeler.map((s) => {
        const secili = s.anahtar === aktif;
        return (
          <button
            key={s.anahtar}
            type="button"
            onClick={() => onSec(s.anahtar)}
            aria-current={secili ? "page" : undefined}
            className={cn(
              "min-h-dokunma rounded-alan px-3.5 text-sm font-medium md:min-h-9",
              "ease-cikis transition-colors duration-(--sure-anlik)",
              secili
                ? "bg-marka-600 text-notr-0"
                : "bg-notr-0 text-notr-700 border-notr-200 hover:bg-notr-100 border",
            )}
          >
            {s.etiket}
          </button>
        );
      })}
    </nav>
  );
}
